import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GridService } from './grid.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  constructor(private gridService: GridService, private configService: ConfigService) { }

  getPrompts(scope: string): Observable<any> {
    let filter = "{}";
    if (scope)
      filter = JSON.stringify({ ScopeCode: scope });
    return this.gridService.getScopeData('AIPROMPTS', 'READ', { ViewCode: "AIPROMPTS.DEFAULT", Filter: filter });
  }
  getScopes(): Observable<any> {
    return this.configService.getScopes();
  }

}
